import {Fetch, ModifyURL} from "@/base/utils/fetch";
import {CartPlans} from "@/base/types/Cart/CartPlans";


export const getCartPlans = async (locale: string): Promise<CartPlans | null> => {
	return Fetch({
		url: ModifyURL(`/cart/config`),
		locale,
	}).then((res: {
		data: CartPlans
	}) => {
		if (!res?.data || Object.keys(res?.data).length === 0)
		{
			throw new Error("Invalid cart config");
		}

		return res?.data || {} as CartPlans;
	});
}